// import React, { useState } from "react";

// const orders = [
//   {
//     orderId: "ORD001",
//     date: "2025-12-15",
//     subadmin: "Kochi Subadmin",
//     seller: "Fresh Mart",
//     orderTotal: 1200,
//     commissionAmount: 120,
//     paymentMode: "ONLINE",
//     commissionStatus: "COLLECTED",
//   },
//   {
//     orderId: "ORD002",
//     date: "2025-12-16",
//     subadmin: "Kochi Subadmin",
//     seller: "Daily Needs",
//     orderTotal: 800,
//     commissionAmount: 80,
//     paymentMode: "COD",
//     commissionStatus: "PENDING",
//   },
//   {
//     orderId: "ORD003",
//     date: "2025-12-16",
//     subadmin: "Trivandrum Subadmin",
//     seller: "Veg Basket",
//     orderTotal: 1500,
//     commissionAmount: 180,
//     paymentMode: "ONLINE",
//     commissionStatus: "COLLECTED",
//   },
// ];

// const AdminOrderCommission = () => {
//   const [subadmin, setSubadmin] = useState("ALL");
//   const [paymentMode, setPaymentMode] = useState("ALL");
//   const [status, setStatus] = useState("ALL");

//   const filteredOrders = orders.filter(o => {
//     return (
//       (subadmin === "ALL" || o.subadmin === subadmin) &&
//       (paymentMode === "ALL" || o.paymentMode === paymentMode) &&
//       (status === "ALL" || o.commissionStatus === status)
//     );
//   });

//   const totalCommission = filteredOrders.reduce(
//     (sum, o) => sum + o.commissionAmount,
//     0
//   );

//   const collected = filteredOrders
//     .filter(o => o.commissionStatus === "COLLECTED")
//     .reduce((sum, o) => sum + o.commissionAmount, 0);

//   const pending = totalCommission - collected;

//   return (
//     <div className="p-6 space-y-6">
//       {/* Filters */}
//       <div className="bg-white p-4 rounded-lg shadow flex flex-wrap gap-4">
//         <Select
//           label="Subadmin"
//           value={subadmin}
//           onChange={setSubadmin}
//           options={["ALL", "Kochi Subadmin", "Trivandrum Subadmin"]}
//         />
//         <Select
//           label="Payment Mode"
//           value={paymentMode}
//           onChange={setPaymentMode}
//           options={["ALL", "ONLINE", "COD"]}
//         />
//         <Select
//           label="Status"
//           value={status}
//           onChange={setStatus}
//           options={["ALL", "COLLECTED", "PENDING"]}
//         />
//       </div>

//       {/* Summary */}
//       <div className="grid grid-cols-4 gap-4">
//         <SummaryCard title="Total Commission" value={`₹${totalCommission}`} />
//         <SummaryCard title="Collected" value={`₹${collected}`} />
//         <SummaryCard title="Pending (COD)" value={`₹${pending}`} />
//         <SummaryCard title="Orders" value={filteredOrders.length} />
//       </div>

//       {/* Table */}
//       <div className="bg-white rounded-lg shadow overflow-x-auto">
//         <table className="w-full text-sm">
//           <thead className="bg-green-50 text-left">
//             <tr>
//               <th className="p-3">Order ID</th>
//               <th className="p-3">Date</th>
//               <th className="p-3">Subadmin</th>
//               <th className="p-3">Seller</th>
//               <th className="p-3">Order Total</th>
//               <th className="p-3">Commission</th>
//               <th className="p-3">Payment</th>
//               <th className="p-3">Status</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredOrders.map(order => (
//               <tr key={order.orderId} className="border-t">
//                 <td className="p-3">{order.orderId}</td>
//                 <td className="p-3">{order.date}</td>
//                 <td className="p-3">{order.subadmin}</td>
//                 <td className="p-3">{order.seller}</td>
//                 <td className="p-3">₹{order.orderTotal}</td>
//                 <td className="p-3 font-semibold text-green-700">
//                   ₹{order.commissionAmount}
//                 </td>
//                 <td className="p-3">{order.paymentMode}</td>
//                 <td className="p-3">
//                   <span
//                     className={`px-2 py-1 rounded text-xs font-medium ${
//                       order.commissionStatus === "COLLECTED"
//                         ? "bg-green-100 text-green-700"
//                         : "bg-yellow-100 text-yellow-700"
//                     }`}
//                   >
//                     {order.commissionStatus}
//                   </span>
//                 </td>
//               </tr>
//             ))}
//             {filteredOrders.length === 0 && (
//               <tr>
//                 <td colSpan="8" className="p-4 text-center text-gray-500">
//                   No orders found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// const SummaryCard = ({ title, value }) => (
//   <div className="bg-white rounded-lg shadow p-4">
//     <p className="text-gray-500 text-sm">{title}</p>
//     <p className="text-xl font-bold text-green-700">{value}</p>
//   </div>
// );

// const Select = ({ label, value, onChange, options }) => (
//   <div className="flex flex-col">
//     <label className="text-sm text-gray-600 mb-1">{label}</label>
//     <select
//       value={value}
//       onChange={e => onChange(e.target.value)}
//       className="border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
//     >
//       {options.map(opt => (
//         <option key={opt} value={opt}>
//           {opt}
//         </option>
//       ))}
//     </select>
//   </div>
// );

// export default AdminOrderCommission;



import React, { useEffect, useState } from "react";
import { getOrderCommissionReport } from "../../ApiCalls/Revenue";

const AdminOrderCommission = () => {
  const [orders, setOrders] = useState([]);
  const [summary, setSummary] = useState({
    total_commission: 0,
    collected: 0,
    pending: 0,
    orders: 0,
  });

  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    from_date: "",
    to_date: "",
    subadmin: "ALL",
    payment: "ALL",
    status: "ALL",
  });

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await getOrderCommissionReport(filters);

      // ✅ FIXED RESPONSE MAPPING
      setOrders(res.data || []);
      setSummary(res.summary || {});
    } catch (err) {
      console.error("Commission fetch failed", err);
    } finally {
      setLoading(false);
    }
  };

  // ❌ remove auto fetch on every change
  useEffect(() => {
    fetchData();
  }, []); // initial load only

  return (
    <div className="p-6 space-y-6">
      {/* Filters */}
      <div className="bg-white p-4 rounded-lg shadow flex flex-wrap gap-4 items-end">
        <DateInput
          label="From Date"
          value={filters.from_date}
          onChange={(v) => setFilters({ ...filters, from_date: v })}
        />
        <DateInput
          label="To Date"
          value={filters.to_date}
          onChange={(v) => setFilters({ ...filters, to_date: v })}
        />

        {/* 🔴 subadmin must be ID */}
        <Select
          label="Subadmin"
          value={filters.subadmin}
          onChange={(v) => setFilters({ ...filters, subadmin: v })}
          options={[
            { label: "ALL", value: "ALL" },
            { label: "Pokak Sub Admin", value: 224 },
          ]}
        />

        <Select
          label="Payment"
          value={filters.payment}
          onChange={(v) => setFilters({ ...filters, payment: v })}
          options={[
            { label: "ALL", value: "ALL" },
            { label: "ONLINE PAYMENT", value: "ONLINE PAYMENT" },
            { label: "COD", value: "COD" },
          ]}
        />

        <Select
          label="Status"
          value={filters.status}
          onChange={(v) => setFilters({ ...filters, status: v })}
          options={[
            { label: "ALL", value: "ALL" },
            { label: "COLLECTED", value: "COLLECTED" },
            { label: "PENDING", value: "PENDING" },
          ]}
        />

        {/* ✅ APPLY BUTTON */}
        <button
          onClick={fetchData}
          className="px-4 py-2 bg-green-600 text-white rounded"
        >
          Apply
        </button>
      </div>

      {/* Summary */}
      <div className="grid grid-cols-4 gap-4">
        <SummaryCard title="Total Commission" value={`₹${summary.total_commission}`} />
        <SummaryCard title="Collected" value={`₹${summary.collected}`} />
        <SummaryCard title="Pending" value={`₹${summary.pending}`} />
        <SummaryCard title="Orders" value={summary.orders} />
      </div>

      {/* Table */}
      <div className="bg-white rounded-lg shadow overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-green-50 text-left">
            <tr>
              <th className="p-3">Order ID</th>
              <th className="p-3">Date</th>
              <th className="p-3">Subadmin</th>
              <th className="p-3">Seller</th>
              <th className="p-3">Order Total</th>
              <th className="p-3">Commission</th>
              <th className="p-3">Payment</th>
              <th className="p-3">Status</th>
            </tr>
          </thead>

          <tbody>
            {!loading &&
              orders.map((o, i) => (
                <tr key={i} className="border-t">
                  <td className="p-3">{o.order_id}</td>
                  <td className="p-3">{o.date}</td>
                  <td className="p-3">{o.subadmin || "-"}</td>
                  <td className="p-3">{o.seller || "-"}</td>
                  <td className="p-3">₹{o.order_total}</td>
                  <td className="p-3 font-semibold text-green-700">
                    ₹{o.commission}
                  </td>
                  <td className="p-3">{o.payment}</td>
                  <td className="p-3">
                    <span
                      className={`px-2 py-1 rounded text-xs font-medium ${
                        o.payment === "COD"
                          ? "bg-yellow-100 text-yellow-700"
                          : "bg-green-100 text-green-700"
                      }`}
                    >
                      {o.payment === "COD" ? "PENDING" : "COLLECTED"}
                    </span>
                  </td>
                </tr>
              ))}

            {!loading && orders.length === 0 && (
              <tr>
                <td colSpan="8" className="p-4 text-center text-gray-500">
                  No orders found
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {loading && (
          <div className="p-4 text-center text-gray-500">
            Loading commission report...
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminOrderCommission;
/* ================================
   REUSABLE COMPONENTS
================================ */

const SummaryCard = ({ title, value }) => (
  <div className="bg-white rounded-lg shadow p-4">
    <p className="text-gray-500 text-sm">{title}</p>
    <p className="text-xl font-bold text-green-700">{value}</p>
  </div>
);

const Select = ({ label, value, onChange, options }) => (
  <div className="flex flex-col">
    <label className="text-sm text-gray-600 mb-1">{label}</label>
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="border rounded px-3 py-2"
    >
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  </div>
);

const DateInput = ({ label, value, onChange }) => (
  <div className="flex flex-col">
    <label className="text-sm text-gray-600 mb-1">{label}</label>
    <input
      type="date"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="border rounded px-3 py-2"
    />
  </div>
);
